/**
 * Get unique key for a row based on available identifier fields
 * @param {object} row - The row data object
 * @param {string} rowKeyField - Primary field to use as key
 * @returns {string|number} - Unique identifier for the row
 */
export const getRowKey = (row, rowKeyField = 'id') => {
  return row[rowKeyField] || row.id || row.externalId || row.corporateBeneficiaryId || row.clientId;
};

/**
 * Check if a row is currently selected
 * @param {object} row - The row to check
 * @param {object} selectedRow - Currently selected row
 * @param {string} rowKeyField - Field to use for comparison
 * @returns {boolean} - Whether the row is selected
 */
export const isRowSelected = (row, selectedRow, rowKeyField = 'id') => {
  if (!selectedRow) return false;
  return getRowKey(row, rowKeyField) === getRowKey(selectedRow, rowKeyField);
};
